import { Link } from "react-router-dom";
import "../../styles/HomeNew.css";
import YICUNav from "../../nav/YICU-Nav";

const AWARD_CATEGORIES = [
  {
    title: "Nominations",
    emoji: "📣",
    color: "card--purple",
    chipClass: "lchip--purple",
    accentVar: "var(--pu-500)",
    bgVar: "var(--pu-50)",
    bdVar: "var(--pu-200)",
    eligibility: ["Nominate a young person ages 12–22 who resides in McLean County."],
    forms: [
      { label: "Nomination Form", href: "https://tinyurl.com/yicu-nom" },
    ],
  },
  {
    title: "Individual",
    emoji: "🏆",
    color: "card--pink",
    chipClass: "lchip--pink",
    accentVar: "var(--pk-500)",
    bgVar: "var(--pk-50)",
    bdVar: "var(--pk-200)",
    eligibility: ["Age 12 to 22", "Resident of McLean County"],
    forms: [
      { label: "Application Form", href: "https://tinyurl.com/yicu-app" },
      { label: "Media Release Form", href: "https://docs.google.com/forms/d/e/1FAIpQLSc8EStUPzAvZ3-bVXSIGXjB9rxB1Gjj_bZzkyOk3htZna8Bqw/viewform" },
      { label: "Reference Form", href: "https://docs.google.com/forms/d/e/1FAIpQLScw4hPvcSPG2GcuRQVLS0yfIYrS7L8p9ShD_hHghy7S0GhjHw/viewform?usp=preview" },
    ],
  },
  {
    title: "Team",
    emoji: "👥",
    color: "card--green",
    chipClass: "lchip--green",
    accentVar: "var(--gn-500)",
    bgVar: "var(--gn-50)",
    bdVar: "var(--gn-200)",
    eligibility: ["Team serving McLean County"],
    forms: [
      { label: "Nomination Form", href: "https://forms.gle/PtPXJyyxGXhVZvB5A" },
      { label: "Media Release Form", href: "https://docs.google.com/forms/d/e/1FAIpQLSc8EStUPzAvZ3-bVXSIGXjB9rxB1Gjj_bZzkyOk3htZna8Bqw/viewform" },
    ],
  },
  {
    title: "Advocate",
    emoji: "📢",
    color: "card--purple",
    chipClass: "lchip--purple",
    accentVar: "var(--pu-500)",
    bgVar: "var(--pu-50)",
    bdVar: "var(--pu-200)",
    eligibility: ["Resident of McLean County"],
    forms: [
      { label: "Nomination Form", href: "https://tinyurl.com/yicuadvocate" },
    ],
  },
  {
    title: "Mentor",
    emoji: "🌟",
    color: "card--pink",
    chipClass: "lchip--pink",
    accentVar: "var(--pk-500)",
    bgVar: "var(--pk-50)",
    bdVar: "var(--pk-200)",
    eligibility: ["Resident of McLean County"],
    forms: [
      { label: "Nomination Form", href: "https://docs.google.com/forms/d/e/1FAIpQLSe3sa7fQ2tNCKHI1DrdjzisZzDhUEa_gTBQwBmxxlNe90LTvg/viewform?usp=preview" },
    ],
  },
];

const CRITERIA = [
  "Demonstrates a strong desire to become a better leader in all aspects of life.",
  "Demonstrates the ability to lead and inspire others.",
  "Passion for serving others.",
];

export default function YICUInfo() {
  return (
    <div className="pg">

      {/* ── HERO ── */}
      <section className="hero" style={{ minHeight: "46svh" }}>
        <div className="hero__glow hero__glow--1" />
        <div className="hero__glow hero__glow--2" />
        <div className="hero__glow hero__glow--3" />
        <div className="hero__inner" style={{ gridTemplateColumns: "1fr auto" }}>
          <div className="hero__text">
            <p className="hero__kicker">For A Better Tomorrow</p>
            <h1 className="hero__h1">
              Why I See<br />
              <span className="hero__accent">You (YICU)</span>
            </h1>
            <p className="hero__sub">
              Recognizing and celebrating young adults' leadership skills and
              contributions to the broader community in McLean County.
            </p>
            <div className="hero__pills">
              <span className="pill pill--purple">Ages 12–22</span>
              <span className="pill pill--pink">McLean County</span>
              <span className="pill pill--green">Nov 8 · AgriCenter, 14169 Carole Dr</span>
            </div>
            <div className="hero__ctas">
              <a href="https://tinyurl.com/yicu-nom" target="_blank" rel="noopener noreferrer" className="cta cta--solid">
                Nominate Someone
              </a>
              <a href="https://tinyurl.com/yicu-app" target="_blank" rel="noopener noreferrer" className="cta cta--ghost">
                Apply Now →
              </a>
            </div>
          </div>

          <div className="hero__stats">
            <div className="hstat hstat--soft" style={{ alignItems: "center" }}>
              <img
                src="/images/YICU/2026/YICU2026.png"
                alt="YICU 2026"
                style={{ maxWidth: 140, maxHeight: 70, objectFit: "contain", display: "block" }}
                onError={e => { e.target.style.display = "none"; }}
              />
            </div>
            <div className="hstat hstat--pink">
              <span className="hstat__n">10</span>
              <span className="hstat__l">Winners Chosen</span>
            </div>
            <div className="hstat hstat--purple">
              <span className="hstat__n">$250</span>
              <span className="hstat__l">Per Winner Donated</span>
            </div>
            <div className="hstat hstat--green">
              <span className="hstat__n">Sept 15</span>
              <span className="hstat__l">Deadline</span>
            </div>
          </div>
        </div>
      </section>

      {/* ── YICU NAV ── */}
      <div style={{ maxWidth: "var(--max)", marginInline: "auto", padding: "0 var(--pad)" }}>
        <YICUNav />
      </div>

      {/* ── DEADLINE ALERT ── */}
      <section className="local" style={{ maxWidth: "860px", marginInline: "auto", paddingBottom: 0 }}>
        <div className="lcard" style={{
          background: "var(--pk-50)", borderColor: "var(--pk-500)",
          flexDirection: "row", gap: "1rem", alignItems: "center",
        }}>
          <span style={{ fontSize: "1.5rem", flexShrink: 0 }}>⏰</span>
          <p style={{ fontSize: ".95rem", fontWeight: 700, color: "var(--pk-700)", lineHeight: 1.6 }}>
            Last date for nominations is <strong>Sept 15, 2026</strong>. Applications are also due <strong>Sept 15, 2026</strong>.
          </p>
        </div>
      </section>

      {/* ── ABOUT ── */}
      <section className="local" style={{ maxWidth: "860px", marginInline: "auto" }}>
        <div className="sec-hd">
          <span className="sec-eye">About the Program</span>
          <h2 className="sec-h2">Program Overview</h2>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: ".85rem" }}>
          {[
            "For A Better Tomorrow (FBT) is proud to accept nominations and applications for the 2026 Why I See You (YICU) Service Awards, as part of its mission to recognize and celebrate young adults' leadership skills and contributions to the broader community.",
            "FBT collaborates with other community partners to give special recognition to young adults who have made their mark on our community. FBT's YICU Service Award recognizes and celebrates community service and leadership in McLean County. Proceeds from the event will benefit the diverse efforts supported by FBT, including Youth Global Citizen (YGC).",
          ].map((text, i) => (
            <div key={i} className="lcard" style={{ flexDirection: "row", gap: "1rem", alignItems: "flex-start" }}>
              <span style={{
                flexShrink: 0, width: 10, height: 10, borderRadius: "50%", marginTop: ".55rem",
                background: i === 0 ? "var(--pk-500)" : "var(--pu-500)",
                boxShadow: `0 0 6px ${i === 0 ? "var(--pk-200)" : "var(--pu-200)"}`,
              }} />
              <p style={{ fontSize: ".93rem", color: "var(--muted)", lineHeight: 1.8 }}>{text}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ── AWARD CATEGORIES ── */}
      <section className="local" style={{ background: "var(--off)", maxWidth: "100%", paddingInline: "var(--pad)" }}>
        <div style={{ maxWidth: "var(--max)", marginInline: "auto" }}>
          <div className="sec-hd">
            <span className="sec-eye">How to Apply</span>
            <h2 className="sec-h2">Award Categories</h2>
            <p className="sec-sub">Choose the category that best fits and submit the required forms before the deadline.</p>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))", gap: "1.25rem" }}>
            {AWARD_CATEGORIES.map((cat, i) => (
              <div key={i} className={`ecard ${cat.color}`} style={{ cursor: "default" }}>
                <div className="ecard__icon">{cat.emoji}</div>
                <span className="ecard__label">{cat.title}</span>
                <h3 className="ecard__name">{cat.title} Award</h3>

                {/* Eligibility */}
                <div style={{ marginBottom: ".5rem" }}>
                  <p style={{ fontSize: ".68rem", fontWeight: 700, letterSpacing: ".1em", textTransform: "uppercase", color: "var(--muted)", marginBottom: ".35rem" }}>
                    Eligibility
                  </p>
                  {cat.eligibility.map((e, j) => (
                    <p key={j} style={{ fontSize: ".82rem", color: "var(--muted)", lineHeight: 1.6 }}>• {e}</p>
                  ))}
                </div>

                {/* Forms */}
                <div style={{ display: "flex", flexDirection: "column", gap: ".4rem", marginTop: "auto", paddingTop: ".5rem", borderTop: `1px solid ${cat.bdVar}` }}>
                  <p style={{ fontSize: ".68rem", fontWeight: 700, letterSpacing: ".1em", textTransform: "uppercase", color: "var(--muted)", marginBottom: ".1rem" }}>
                    Required Forms
                  </p>
                  {cat.forms.map((f, j) => (
                    <a key={j} href={f.href} target="_blank" rel="noopener noreferrer"
                      style={{
                        fontSize: ".78rem", fontWeight: 700, color: cat.accentVar,
                        textDecoration: "none", display: "flex", alignItems: "center", gap: ".3rem",
                      }}>
                      ↗ {f.label}
                    </a>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CRITERIA + EVENT INFO ── */}
      <section className="local" style={{ maxWidth: "860px", marginInline: "auto" }}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1.25rem" }}>

          {/* Selection Criteria */}
          <div className="lcard lcard--open" style={{ gap: "1rem" }}>
            <div style={{ display: "flex", alignItems: "center", gap: ".75rem" }}>
              <span style={{ fontSize: "1.4rem" }}>🎯</span>
              <h3 style={{ fontFamily: "var(--ff-head)", fontSize: "1rem", fontWeight: 800, color: "var(--ink)" }}>
                Selection Criteria
              </h3>
            </div>
            <div style={{ borderTop: "1px solid var(--pu-200)", paddingTop: ".75rem", display: "flex", flexDirection: "column", gap: ".6rem" }}>
              {CRITERIA.map((c, i) => (
                <div key={i} style={{ display: "flex", gap: ".6rem", alignItems: "flex-start" }}>
                  <span style={{ color: "var(--pu-500)", fontWeight: 800, flexShrink: 0 }}>✓</span>
                  <p style={{ fontSize: ".86rem", color: "var(--muted)", lineHeight: 1.7 }}>{c}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Event Info */}
          <div className="lcard" style={{ background: "var(--pk-50)", borderColor: "var(--pk-200)", gap: "1rem" }}>
            <div style={{ display: "flex", alignItems: "center", gap: ".75rem" }}>
              <span style={{ fontSize: "1.4rem" }}>📍</span>
              <h3 style={{ fontFamily: "var(--ff-head)", fontSize: "1rem", fontWeight: 800, color: "var(--ink)" }}>
                Event Info
              </h3>
            </div>
            <div style={{ borderTop: "1px solid var(--pk-200)", paddingTop: ".75rem", display: "flex", flexDirection: "column", gap: ".6rem" }}>
              {[
                "FBT's YICU Service Awards Celebration will be held at AgriCenter, 14169 Carole Drive, Bloomington IL 61705, November 8 at 2 PM.",
                "Ten winners will be announced from the nominees — three from each age category and one at large.",
              ].map((t, i) => (
                <div key={i} style={{ display: "flex", gap: ".6rem", alignItems: "flex-start" }}>
                  <span style={{ color: "var(--pk-500)", fontWeight: 800, flexShrink: 0 }}>•</span>
                  <p style={{ fontSize: ".86rem", color: "var(--muted)", lineHeight: 1.7 }}>{t}</p>
                </div>
              ))}
            </div>
          </div>

        </div>
      </section>

      {/* ── DONATION QUOTE ── */}
      <div className="quote-band">
        <p>"FBT will make a $250 donation towards a non-profit in honor of each award winner."</p>
      </div>

      {/* ── SPONSOR CTA ── */}
      <section className="local" style={{ maxWidth: "700px", marginInline: "auto" }}>
        <div className="lcard" style={{
          background: "var(--pk-50)", borderColor: "var(--pk-500)",
          alignItems: "center", textAlign: "center", padding: "2rem",
          gap: "1rem",
        }}>
          <span style={{ fontSize: "2rem" }}>🤝</span>
          <h3 style={{ fontFamily: "var(--ff-head)", fontSize: "1.1rem", fontWeight: 800, color: "var(--ink)" }}>
            Become a YICU Sponsor
          </h3>
          <p style={{ fontSize: ".9rem", color: "var(--muted)", lineHeight: 1.7 }}>
            Be a sponsor for the YICU Award and help us celebrate the next generation of community leaders.
          </p>
          <a
            href="mailto:contactus@forbettertomorrow.org"
            className="lcard__toggle"
            style={{
              textDecoration: "none", display: "inline-block",
              borderColor: "var(--pk-300)", color: "var(--pk-500)",
            }}
          >
            contactus@forbettertomorrow.org →
          </a>
        </div>
      </section>

    </div>
  );
}